/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner, Button } from "react-bootstrap";
import Loader from "../loader/loader";
import Layout from "../layout/layout";
import RarityToolCard from "./rarityToolCard";
import GemologicalCharacteristics from "./gemologicalCharacteristics";
import FcrfContext from "../../Context";
import { rarityInstance, withAuth } from "../../config/axios";
import { resultFormating } from "../../utils/resultFormating";
import { getlocalStorage } from "../../utils/getlocalStorage";
import { clientPath, serverPath } from "../../config/key";
import { queryString } from "../../utils/queryString";
import { getFormattedDate } from "../../utils/dateUtils";
import VerticalDropdown from "../verticalDropdown/verticalDropdown";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  SaveIcons,
  HistoryIcons,
  SettingsIcons,
  DiamondIcon,
} from "../verticalDropdown/svgData";
import RarityHighlightedBox from "./rarityHighlightedBox";
import "./rarityReport.css";
import RarityInfo from "./rarityInfo";
import SaveNotificationModal from "../Models/saveNotificationModal";
import ScrollToTop from "../common/scrolltotop";
import MarketDistribution from "./marketDistribution";

const RarityReport = ({ handleBackRairity, handleOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [characteristics, setCharacteristics] = useState({});
  const [bubble_texts, setBubbleText] = useState({});
  const [animationText, setAnimationText] = useState(null);
  const [range_slider, setRangeSlider] = useState({});
  const [labelName, setLabelName] = useState([]);
  const [tooltip_text, setTooltipText] = useState([]);
  const [labelValue, setLabelValue] = useState([]);
  const setContext = useContext(FcrfContext);
  const getContext = useContext(FcrfContext);

  const { dateSetting, savedNotification, setSavedNotification } = getContext;

  const [reportData, setReportData] = useState({});
  const {report_number} = reportData?.data || {}
  // eslint-disable-next-line no-unused-vars
  const [reportId, setReportId] = useState({ Id: "", postId: "" });
  const [copied, setCopied] = useState(false);
  const { Id, from } = queryString();
  const [urlValue, setUrlValue] = useState(null);
  const [, setReportGeneratedDate] = useState("");
  const [isPdf, setisPdf] = useState(false);
  const [, setImgScaleVal] = useState(1);
  const [isActive, setisActive] = useState(false);
  const [fromgia] = useState(location?.state?.type === "fromgia");
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const { action } = location.state ?? {};
    console.log("action =>", location.state);
    if (action !== "Create") {
      getReportById();
    }
    if (action === "Create") {
      const { report, id } = location.state ?? {};
      const { data, graph_texts, bubble_texts, range_slider, postId } =
        report || {};
      const { labelname, graph_tooltip_text, labelvalue } = resultFormating(
        graph_texts,
        range_slider,
        data
      );

      const obj = {
        Id: id,
        postId: postId,
      };
      setReportId(obj);
      handleShare(obj);
      setReportData(report);
      setLabelName(labelname);
      setLabelValue(labelvalue);
      setTooltipText(graph_tooltip_text);
      setBubbleText(bubble_texts);
      AnimateStringData(bubble_texts?.D18);
      setRangeSlider(range_slider);
      console.log("============================================", data);
      setCharacteristics(data);

      setLoading(false);
    }
  }, []);

  console.log(location?.state?.type === "fromgia", location?.state?.type);
  const handleCreateNewReport = () => {
    window.history.pushState("1", null, "/");
    setContext.setSetps(1);

    navigate("/", {
      state: {
        tab: "tab1",
        showGia: fromgia,
      },
    });
  };

  const AnimateStringData = (inputString) => {
    console.log({ inputString });
    let Text = inputString?.split("#") || [];

    const parts = Text[1]?.split("~");

    if (parts?.length === 2) {
      const secondString = parts[1].trim().replace(/,/g, "");
      setAnimationText(Number(secondString));
      return secondString;
    } else {
      setAnimationText(null);
      return null;
    }
  };

  const getReportById = async () => {
    setLoading(true);
    try {
      const { id } = location?.state || {};
      let postid = id;
      if (from === "diary") {
        postid = `#${Id}`;
      }
      const rairtyID = id?.replace("#", "");
      const response = await withAuth().get(`report/getreport?Id=${rairtyID}`);
      const { status, getReport } = response?.data;

      const { _id, report, timestamp } = getReport || {};
      if (status === 200) {
        const obj = {
          Id: _id,
          postId: postid,
        };
        setReportId(obj);
        const { data, graph_texts, bubble_texts, range_slider } = report || {};
        const { labelname, graph_tooltip_text, labelvalue } = resultFormating(
          graph_texts,
          range_slider,
          data
        );
        setReportGeneratedDate(getFormattedDate(timestamp || new Date()));
        setReportData(report);
        setLabelName(labelname);
        setLabelValue(labelvalue);
        setTooltipText(graph_tooltip_text);
        setBubbleText(bubble_texts);
        AnimateStringData(bubble_texts?.D18);
        setRangeSlider(range_slider);
        console.log("============================================", data);
        console.log("============================================", data);
        setCharacteristics(data);
        handleShare(obj);
        setLoading(false);
        const diaryId = localStorage.getItem("sendViewRarity");
        if (from === "diary" && diaryId) {
          try {
            const shareLink = `${clientPath}/share-rarity-report/${obj.Id}`;
            await rarityInstance().post("report/rarity-from-diary", {
              rarityUrl: shareLink,
              rarityReportId: postid,
              reportId: diaryId,
              reportData: report,
            });
            localStorage.removeItem("sendViewRarity");
          } catch (error) {
            console.log("error in rarity-from-diary api", error);
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDownLoadReport = async (toPdf) => {
    setisPdf(true);
    window.open(reportData.extraritypdfUrl);
    setisPdf(false);
    const copyfilterdata = { ...reportData };
    const { is_free } = getlocalStorage();
    copyfilterdata.free = is_free;

    copyfilterdata.type = "Rarity Export";

    copyfilterdata.stringDate = dateSetting?.stringDate;
    copyfilterdata.shareUrl = urlValue;
    const response = await rarityInstance().post(
      "report/downloadReport",
      copyfilterdata
    );
    const { status } = response?.data;
    if (status === 200) {
    }
    setisPdf(false);
  };

  const handleShare = async (obj) => {
    const shareLink = `${serverPath}/share-rarity-report/${obj.Id}`;
    setUrlValue(shareLink);
  };
  const handleCopy = async () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 300);
    try {
      await rarityInstance().post("report/copy-share-link/Rarity", {
        reportId: reportId.postId,
        shareLink: urlValue,
      });
    } catch (error) {
      console.error("error in copy link===", error);
    }
  };

  const formatDateWebReport = (input) => {
    const dateObject = new Date(input);
    if (isNaN(dateObject.getTime())) {
      return "Invalid Date";
    }
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1;
    let monthName;

    switch (month) {
      case 1:
        monthName = "January";
        break;
      case 2:
        monthName = "February";
        break;
      case 3:
        monthName = "March";
        break;
      case 4:
        monthName = "April";
        break;
      case 5:
        monthName = "May";
        break;
      case 6:
        monthName = "June";
        break;
      case 7:
        monthName = "July";
        break;
      case 8:
        monthName = "August";
        break;
      case 9:
        monthName = "September";
        break;
      case 10:
        monthName = "October";
        break;
      case 11:
        monthName = "November";
        break;
      case 12:
        monthName = "December";
        break;
      default:
        monthName = "Invalid month";
    }
    const year = dateObject.getFullYear();

    const formattedDate = `${monthName} ${day}, ${year}`;
    return formattedDate;
  };
  const formatDate = (inputDate) => {
    const dateComponents = inputDate?.match(
      /(\w+) (\d+)(?:st|nd|rd|th), (\d+)/
    );
    if (!dateComponents) {
      return "Invalid Date";
    }
    const months = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    const month = months[dateComponents[1]];
    const day = dateComponents[2];
    const year = dateComponents[3];
    const date = new Date(year, month, day);
    const lastTwoDigitsOfYear = year % 100;
    const formattedDate = `${date.getDate()}.${
      date.getMonth() + 1
    }.${lastTwoDigitsOfYear}`;
    return formattedDate;
  };

  const divRef = useRef(null);
  const [, setMinHeight] = useState("");

  const handleResize = () => {
    if (divRef.current) {
      const MinHeight = divRef.current.clientHeight;
      setMinHeight(MinHeight);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const sizeValueInit =
    reportData?.gia_report?.results?.data?.measurements?.length /
      reportData?.gia_report?.results?.data?.measurements?.width || 0;

  const sizeValue =
    Number(sizeValueInit.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]) || 0;

  useEffect(() => {
    if (
      reportData?.data?.shapeCategory === "Cushion" ||
      reportData?.data?.shapeCategory === "Radiant"
    ) {
      if (sizeValue <= 1.05) {
        setImgScaleVal(1);
      } else if (sizeValue >= 1.06 && sizeValue <= 1.14) {
        setImgScaleVal(1.075);
      } else if (sizeValue >= 1.15 && sizeValue <= 1.24) {
        setImgScaleVal(1.15);
      } else if (sizeValue >= 1.25 && sizeValue <= 1.34) {
        setImgScaleVal(1.225);
      } else if (sizeValue >= 1.35) {
        setImgScaleVal(1.3);
      }
    } else if (reportData?.data?.shapeCategory === "Emerald") {
      if (sizeValue <= 1.14) {
        setImgScaleVal(0.775);
      } else if (sizeValue >= 1.15 && sizeValue <= 1.24) {
        setImgScaleVal(0.85);
      } else if (sizeValue >= 1.25 && sizeValue <= 1.34) {
        setImgScaleVal(0.925);
      } else if (sizeValue >= 1.35 && sizeValue <= 1.44) {
        setImgScaleVal(1);
      } else if (sizeValue >= 1.45) {
        setImgScaleVal(1.075);
      }
    }
  }, [sizeValue]);

  const handleSaveReport = async () => {
    setisActive(true);
    const response = await rarityInstance().post("report/saveRarityReport", {
      reportId,
      recordName: reportData
        ? `${reportData?.data?.saturation} ${reportData?.data?.colorName} ${reportData?.data?.weight}ct`
        : "",
    });
    if (response) {
      const copyfilterdata = { ...response.data.report?.report };
      const { is_free, is_subscription, is_role, service } = getlocalStorage();
      copyfilterdata.free = is_free;
      copyfilterdata.subscription = is_subscription || "not active";
      copyfilterdata.role = is_role;
      copyfilterdata.type = "Rarity saved";
      copyfilterdata.service = service;

      rarityInstance().post("report/reportwebhook", copyfilterdata);
      setSavedNotification(true);
      setisActive(false);
      setTimeout(() => {
        setSavedNotification(false);
        navigate("/rarity-save-history");
      }, 1000);
    }
  };

  const dropdownItems = [
    {
      icon: HistoryIcons,
      route: "/saved-report?report",
      label: "Search History",
    },
    {
      icon: SaveIcons,
      route: "/rarity-save-history",
      label: "Saved Reports",
      sharefun: handleSaveReport,
    },
    { icon: SettingsIcons, route: `/settings`, label: "Report Settings" },
  ];

  if (reportData?.gia_report?.report_number) {
    dropdownItems.push({
      icon: DiamondIcon,
      route: `/valuation/?gia=${reportData?.gia_report?.report_number}`,
      label: "Ask for Valuation",
    });
  }

  const highlightText =
    reportData?.bubble_texts?.D18?.split("#")[1]?.split(" ")?.at(-1) || "";

  console.log("report", reportData);

  return (
    <>
      {loading && <Loader type={"progress"} setLoading={setLoading} />}
      <Layout handleBackRairity={handleBackRairity} handleOpen={handleOpen}>
        <div className="rarity-report-page updated_raritypage">
          <div className="rarity-report-head"></div>
          <div className="rarity-report-content">
            <div className="container">
              <div className="rarity-tool">
                <div className="rarity-header-section grade-desktop-view">
                  <div className="rarity-header-right rarity-header-right-updated">
                    <div className="report-action-btn">
                      <Button
                        className="outline-btn"
                        onClick={() => handleCreateNewReport()}
                      >
                        <PlusIcon />
                        New
                      </Button>
                      <Button
                        className="outline-btn pdf-btn"
                        onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                      >
                        {isPdf ? (
                          <Spinner animation="border" />
                        ) : (
                          <>
                            {" "}
                            <DownloadIcon />
                            <span>PDF</span>
                          </>
                        )}
                      </Button>

                      <Button
                        disabled={isActive}
                        className="outline-btn"
                        onClick={() => handleSaveReport()}
                      >
                        <SaveIcons />

                        {isActive ? <Spinner animation="border" /> : "Save"}
                      </Button>
                      <div className="copy-btn-wrapper">
                        {urlValue && (
                          <CopyToClipboard
                            text={urlValue}
                            onCopy={(e) => handleCopy(e)}
                          >
                            <Button className="outline-btn">
                              <ExportIcon />
                            </Button>
                          </CopyToClipboard>
                        )}

                        <span
                          className={`copied-tooltip ${copied ? "show" : ""}`}
                        >
                          Copied
                        </span>
                      </div>
                    </div>

                    <VerticalDropdown dropdownItems={dropdownItems} />
                  </div>
                </div>

                <div className="rarity-header-section grade-mob-view">
                  <div className="rarity-header-right">
                    <div className="report-action-btn">
                      <Button
                        className="outline-btn"
                        onClick={() => handleCreateNewReport()}
                      >
                        <PlusIcon />
                      </Button>
                      <Button
                        className="outline-btn pdf-btn"
                        onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                      >
                        {isPdf ? (
                          <Spinner animation="border" />
                        ) : (
                          <>
                            {" "}
                            <DownloadIcon />
                          </>
                        )}
                      </Button>

                      <Button
                        disabled={isActive}
                        className="outline-btn  "
                        onClick={() => handleSaveReport()}
                      >
                        {isActive ? (
                          <Spinner animation="border" />
                        ) : (
                          <SaveIcons />
                        )}
                      </Button>
                      <div className="copy-btn-wrapper">
                        {urlValue && (
                          <CopyToClipboard
                            text={urlValue}
                            onCopy={(e) => handleCopy(e)}
                          >
                            <Button className="outline-btn">
                              <ExportIcon />
                            </Button>
                          </CopyToClipboard>
                        )}

                        <span
                          className={`copied-tooltip ${copied ? "show" : ""}`}
                        >
                          Copied
                        </span>
                      </div>
                    </div>
                    <VerticalDropdown dropdownItems={dropdownItems} />
                  </div>
                </div>


                <div className="rarity-tool-grid updatedrarity-tool-grid ">
                  <div className="updated_rarity_pdf">
                    <div className="rarity_report_top">
                      <div className="rarity_report_top_left">
                        <div className="rarity-fcrf-logo">
                          <img  src={`${ clientPath }/icons/FCRF_logo.svg`} alt="Logo" />
                        </div>
                        <div className="rarity_report_top_left_desc">
                          <h6>Gemological properties:</h6>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Carat weight:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">{parseFloat(reportData?.data?.weight).toFixed(2)}</div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Saturation:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">{reportData?.data?.saturation}</div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Color:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">
                            {reportData?.data?.report_number === "" || !reportData?.data?.report_number ? reportData?.data?.color : reportData?.data?.colorName} {(reportData?.data?.color ==="Chameleon" && reportData?.data?.report_number) &&  <div>
                            <span>*</span>
                          </div> }
                            </div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Shape:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">
                            {reportData?.data?.report_number === "" || !reportData?.data?.report_number ? reportData?.data?.shape : reportData?.range_slider?.shapeName}
                            </div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Clarity:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">{reportData?.data?.report_number === "" || !reportData?.data?.report_number ? reportData?.data?.clarity : reportData?.data?.giaclarity}</div>
                          </p>
                       {
                        !(reportData?.data?.report_number === "" || !reportData?.data?.report_number) ? (
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`} style={{
                            color: '#767676'
                          }}>
                            <div className="rarity-gemological-text">
                              GIA
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`} style={{borderBottom: '3px dotted #767676'}}></div>
                            <div className="rarity-gemological-text">
                            No. {reportData?.data?.report_number}
                            </div>
                          </p>
                        ) : null
                       }

{(reportData?.data?.color ==="Chameleon" && reportData?.data?.report_number) &&  <div>
                            <span>*Chameleon</span>
                          </div> }

                        </div>
                      </div>
                      <div className="rarity_report_top_right">
                        <div className="diamond-desc-img">
                          <div className="rarity-right-title">
                            <h4>The Rarity Report</h4>
                          </div>

                          <div className="rarity-right-img-data">
                            <p className="report-date m-0">
                              {formatDateWebReport(reportData?.timestamp)}
                            </p>
                            <p className="report-number m-0">
                              REPORT {reportData?.postId}
                            </p>
                          </div>

                          <div className="divider"></div>

                          <div className="bottom-logo">
                            <img
                              src="https://fcrf-object-store.s3.eu-central-1.amazonaws.com/logo/1728647326686"
                              alt="Bottom Logo"
                              className="invisible"
                            />
                          </div>

                          <div className="rarity-note">
                            Rarity data refers to a natural color diamond with
                            the described gemological properties
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="diamond-grade ">
                      <div className="grade-section">
                        <p className="text-block">
                          <span className="main-text">rarity</span>
                          <span className="highlight-text">
                            ONE IN {highlightText}
                          </span>
                        </p>

                        <p className="text-block">
                          <span className="main-text">market entry</span>
                          <span className="highlight-text market-highlight">
                            {" "}
                            {reportData?.bubble_texts?.H18?.replaceAll(
                              "#",
                              ""
                            )}{" "}
                          </span>

                        </p>
                      </div>
                    </div>

                    <div className="graph_section_rarity">
                      <div className="graph_section_rarity-left">
                        <h6 className="graph_section_text">
                          Market Distribution Percentage
                        </h6>
                        <div className="graph_section_chartdata">
                          <div className="updatedchart">
                            <MarketDistribution
                              graph_texts={tooltip_text}
                              labelValue={labelValue}
                              labelName={labelName}
                              loading={false}
                            />
                          </div>
                          <div>
                            <div className="divider"></div>

                            <h1 className="update-text">
                              The Fancy Color Research Foundation
                            </h1>
                          </div>
                        </div>
                      </div>

                      <div className="graph_section_rarity-right graph_section_rarity-left">
                        <h6 className="graph_section_text">
                          Denomination Brackets
                        </h6>
                        <div className="market-distribution-top">
                          <div className="market-distribution">
                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Remarkable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">Once</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">every 25y</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Remarkable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Remarkable
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Exceptional"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                {" "}
                                <div className="tab-text-card">Once</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">
                                  every 13 - 24y
                                </div>{" "}
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Exceptional"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Exceptional
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extremely Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">Once</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">
                                  every 1 - 12y
                                </div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extremely Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Extremely Rare
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">1-3</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Very Rare
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">3-10</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Rare
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extraordinary"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">10-40</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extraordinary"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Extraordinary
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">40-180</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Very Special
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">180-400</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Special
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Outstanding"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">400-900</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Outstanding"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Outstanding
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Notable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">900-10,000</div>
                                <div className="dotted-text"></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`distribution-label ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Notable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Notable
                              </span>
                            </div>
                          </div>
                          <div className="divider-mt">
                            <div className="divider"></div>
                            <h1 className="update-text">
                              Last data update on{" "}
                              {formatDate(reportData?.textSheetData?.H12)}
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="rarity_report_top update-rarity-bottom">
                      <p>
                        The data acquired from The Fancy Color Diamond Rarity
                        Report©. may change from time to time and is not a
                        guarantee nor a reflection of the diamond’s value. For
                        additional information regarding the data, and other
                        limitations, contact us at:{" "}
                        <a href="mailto:customers@fcresearch.org">
                          customers@fcresearch.org
                        </a>
                      </p>
                    </div>
                  </div>
                </div>



                <div className="rarity-tool-grid old-rarity-report rarity-mob-updated">
                  <div className="rarity-tool-left ">
                    <div>
                      <div className="rarity-heading-wrapper card-pd rarity-page-header">
                        <div className="rarity_report_top_heading ">
                          <h1 className="relative rarity_report_head_top ">the rarity report

                          </h1>
                        </div>
                      </div>
                      <div className="rarity-right-img-data updated-mob-rarity">
                        <p className="report-date m-0">
                          {formatDateWebReport(reportData?.timestamp)}
                        </p>
                        <p className="report-number m-0">
                          REPORT {reportData?.postId}
                        </p>
                      </div>
                      <div className="divider update-divider"></div>
                      <div className="rarity-note update-rarity-note">
                        Rarity data refers to a natural color diamond with the
                        described gemological properties
                      </div>

                      <div className="rarity_report_gemological_properties">
                        <h6>Gemological Properties</h6>
                        <p>
                          {parseFloat(reportData?.data?.weight).toFixed(2)} ct,{" "}
                          {reportData?.data?.saturation},{" "}
                          {reportData?.data?.color === "Chameleon" &&
                          reportData?.data?.report_number
                            ? `${reportData?.data?.colorName} - Chameleon`
                            : !reportData?.data?.report_number
                            ? reportData?.data?.color
                            : reportData?.data?.colorName}
                          ,{" "}
                          {reportData?.data?.report_number === "" ||
                          !reportData?.data?.report_number
                            ? reportData?.data?.shape
                            : reportData?.range_slider?.shapeName}
                          ,{" "}
                          {reportData?.data?.report_number === "" ||
                          !reportData?.data?.report_number
                            ? reportData?.data?.clarity
                            : reportData?.data?.giaclarity}{" "}
                        </p>
                        {reportData?.data?.report_number && (
                          <span>GIA No. {reportData?.data?.report_number}</span>
                        )}
                      </div>
                    </div>

                    <div className="grade-mob-view">
                      <div className="rarity-highlighted-box highlight-box1">
                        <div className="text-block ">
                          <h6 className="main-text">rarity</h6>
                          <p className="highlight-text">
                            ONE IN {highlightText}
                          </p>
                        </div>
                      </div>

                      <div className="rarity-highlighted-box highlight-box1 highlight-box2">
                        <div className="text-block ">
                          <h6 className="main-text">market entry</h6>

                          <p className="highlight-text">
                            {reportData?.bubble_texts?.H18?.split("#")[0]}
                          </p>
                          <p className="highlight-text">
                            {reportData?.bubble_texts?.H18?.split("#")[1]}
                          </p>

                        </div>
                        {!showContent && (
                          <p
                            className="text-decoration-underline learn-about-text"
                            onClick={() => setShowContent(!showContent)}
                          >
                            learn about the rarity levels
                          </p>
                        )}

                        {
                          <div
                            className={`graph_section_rarity-right graph_section_rarity-left ${
                              showContent
                                ? "rarity-level-text-animation"
                                : "collapsed"
                            }`}
                          >
                            <h6 className="graph_section_text">
                              Denomination Brackets
                            </h6>
                            <div className="market-distribution-top">
                              <div className="market-distribution">
                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Remarkable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">Once</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">
                                      every 25y
                                    </div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Remarkable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Remarkable
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Exceptional"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    {" "}
                                    <div className="tab-text-card">Once</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">
                                      every 13 - 24y
                                    </div>{" "}
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Exceptional"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Exceptional
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extremely Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">Once</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">
                                      every 1 - 12y
                                    </div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extremely Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Extremely Rare
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">1-3</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Very Rare
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">3-10</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Rare
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extraordinary"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">10-40</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extraordinary"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Extraordinary
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">40-180</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Very Special
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">180-400</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Special
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Outstanding"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">400-900</div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Outstanding"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Outstanding
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Notable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">
                                      900-10,000
                                    </div>
                                    <div className="dotted-text"></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`distribution-label ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Notable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Notable
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        </div>

                    </div>

                    <div className="card-pd card-height">
                      <GemologicalCharacteristics
                        graph_texts={tooltip_text}
                        labelValue={labelValue}
                        labelName={labelName}
                        loading={false}
                        section={"rarity"}
                      />
                    </div>


                  </div>

                  <div className="rarity-tool-right ">
                    <div className="rarity-time-report-no-wrapper grade-desktop-view">
                      <h5>{getFormattedDate(reportData?.timestamp)}</h5>
                      <p>Report {reportData?.postId}</p>
                    </div>
                    <div
                      className="grade-desktop-view cardHightRight1"
                      ref={divRef}
                    >
                      <RarityToolCard
                        cardDesc={
                          "Fancy Color Diamond appreciation revolves around beauty and rarity. The Rarity Report illustrates the market prevalence of a polished diamond. Whether a diamond is one of several hundred or is introduced to the market once a decade, rarity was, and always will be, a part of the epic story of a fancy color diamond."
                        }
                        loading={false}
                        line={2}
                        className="rarity-left-content-alignment"
                      />
                    </div>
                    <div
                      className={`grade-desktop-view ${
                        characteristics.report_number
                          ? "share-rarity-grade"
                          : "right_grade"
                      }`}
                    >
                      <RarityHighlightedBox
                        range_slider={range_slider}
                        cardDesc={bubble_texts?.H18}
                        animationText={animationText}
                        loading={loading}
                      />
                    </div>

                    <RarityInfo range_slider={range_slider} />

                  </div>
                </div>

                <div className="report-action-footer ">
                  <div className="report-action-btn action-btn-mob">
                    <Button
                      className="outline-btn"
                      onClick={() => handleCreateNewReport()}
                    >
                      <PlusIcon />
                      New
                    </Button>
                    <Button
                      className="outline-btn pdf-btn"
                      onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                    >
                      {isPdf ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          {" "}
                          <DownloadIcon />
                          PDF
                        </>
                      )}
                    </Button>

                    <Button
                      disabled={isActive}
                      className="outline-btn"
                      onClick={() => handleSaveReport()}
                    >
                      <SaveIcons />

                      {isActive ? <Spinner animation="border" /> : "Save"}
                    </Button>

                    <div className="copy-btn-wrapper">
                      {urlValue && (
                        <CopyToClipboard
                          text={urlValue}
                          onCopy={(e) => handleCopy(e)}
                        >
                          <Button className="outline-btn">
                            <ExportIcon />
                          </Button>
                        </CopyToClipboard>
                      )}

                      <span
                        className={`copied-tooltip ${copied ? "show" : ""}`}
                      >
                        Copied
                      </span>
                    </div>
                  </div>

                  <div className="rarity-header-section grade-mob-view">
                    <div className="rarity-header-right">
                      <div className="report-action-btn">
                        <Button
                          className="outline-btn"
                          onClick={() => handleCreateNewReport()}
                        >
                          <PlusIcon />
                        </Button>
                        <Button
                          className="outline-btn pdf-btn"
                          onClick={() =>
                            handleDownLoadReport(reportData?.pdfurl)
                          }
                        >
                          {isPdf ? (
                            <Spinner animation="border" />
                          ) : (
                            <>
                              {" "}
                              <DownloadIcon />
                            </>
                          )}
                        </Button>

                        <Button
                          disabled={isActive}
                          className="outline-btn  "
                          onClick={() => handleSaveReport()}
                        >
                          {isActive ? (
                            <Spinner animation="border" />
                          ) : (
                            <SaveIcons />
                          )}
                        </Button>

                        <div className="copy-btn-wrapper">
                          {urlValue && (
                            <CopyToClipboard
                              text={urlValue}
                              onCopy={(e) => handleCopy(e)}
                            >
                              <Button className="outline-btn">
                                <ExportIcon />
                              </Button>
                            </CopyToClipboard>
                          )}

                          <span
                            className={`copied-tooltip ${copied ? "show" : ""}`}
                          >
                            Copied
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="rarity-tool-bottom-text-padding1">
                        <p className="rarity-tool-text mb-2">
                          The data acquired from The Fancy Color Diamond Rarity
                          Report©. may change from time to time and is not a
                          guarantee nor a reflection of the diamond’s value. For
                          additional information regarding the data, and other
                          limitations, contact us at: customers@fcresearch.org
                        </p>

                        <p className="report-timestamp   rarity-report-time-stamp grade-mob-view">
                          <span className="update-text last-date">
                            {" "}
                            Last data update on{" "}
                            {formatDate(reportData?.textSheetData?.H12)}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop scrollClass={"scroll-up"} />


        {savedNotification && (
          <SaveNotificationModal
            message={"Report Saved successfully"}
            undoBtn={false}
          />
        )}
      </Layout>
    </>
  );
};

export default RarityReport;

const DownloadIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.156 15.242c.232 0 .447.097.6.25A.9.9 0 0 1 21 16.1v3.991l-.008.115-.02.107a.856.856 0 0 1-.833.687H3.856a.853.853 0 0 1-.845-.76C3 20.187 3 20.142 3 20.085v-3.992c0-.471.385-.852.85-.852a.852.852 0 0 1 .85.852v3.197h14.605v-3.197c0-.471.386-.852.85-.852zM12.01 3c.272 0 .522.114.703.29a.983.983 0 0 1 .29.704v9.215l2.51-2.515a.998.998 0 0 1 1.405 0 1.018 1.018 0 0 1-.017 1.408l-4.177 4.185c-.005.011-.017.017-.022.023a.984.984 0 0 1-.55.278c-.017 0-.034.006-.051.006l-.051.005H12l-.096-.005c-.017 0-.034-.006-.051-.006a.966.966 0 0 1-.55-.278l-.023-.023-4.177-4.185a.994.994 0 0 1-.289-.704c0-.255.097-.51.29-.704a.998.998 0 0 1 1.405 0l2.51 2.515V3.994c0-.545.448-.994.992-.994z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};

const PlusIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 13H3v-2h8V3h2v8h8v2h-8v8h-2z"
        fill="#bf8f02"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ExportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74707 4.00047H10.2111C10.4011 4.00053 10.584 4.07271 10.7229 4.20244C10.8617 4.33217 10.9461 4.50977 10.9591 4.69935C10.972 4.88893 10.9126 5.07636 10.7926 5.22377C10.6727 5.37117 10.5013 5.46757 10.3131 5.49347L10.2111 5.50047H6.74707C6.17711 5.50038 5.62835 5.71661 5.21164 6.10547C4.79493 6.49434 4.54133 7.02686 4.50207 7.59547L4.49707 7.75047V17.2505C4.49725 17.8204 4.71373 18.3691 5.10278 18.7856C5.49183 19.2021 6.02445 19.4555 6.59307 19.4945L6.74707 19.5005H16.2471C16.8172 19.5005 17.3661 19.2842 17.7828 18.8951C18.1996 18.506 18.453 17.9733 18.4921 17.4045L18.4971 17.2505V16.7525C18.4951 16.5611 18.5664 16.3762 18.6963 16.2357C18.8263 16.0952 19.005 16.0096 19.1959 15.9966C19.3869 15.9835 19.5756 16.044 19.7234 16.1656C19.8712 16.2871 19.967 16.4606 19.9911 16.6505L19.9971 16.7525V17.2505C19.9969 18.2103 19.6287 19.1335 18.9683 19.83C18.3079 20.5265 17.4055 20.9433 16.4471 20.9945L16.2471 21.0005H6.74707C5.78691 21.0005 4.8633 20.6323 4.16656 19.9717C3.46981 19.311 3.05302 18.4083 3.00207 17.4495L2.99707 17.2495V7.74947C2.99724 6.78964 3.36544 5.86642 4.02586 5.16992C4.68627 4.47341 5.58861 4.05666 6.54707 4.00547L6.74707 4.00047ZM14.5001 6.52047V3.75047C14.5 3.61251 14.538 3.47721 14.6098 3.35943C14.6816 3.24166 14.7846 3.14599 14.9073 3.08293C15.03 3.01987 15.1677 2.99188 15.3053 3.00203C15.4428 3.01218 15.575 3.06009 15.6871 3.14047L15.7691 3.20847L21.7631 8.95847C22.0431 9.22747 22.0691 9.65847 21.8401 9.95647L21.7631 10.0415L15.7691 15.7935C15.6695 15.8891 15.5455 15.9553 15.4108 15.985C15.276 16.0147 15.1356 16.0066 15.0051 15.9616C14.8747 15.9166 14.7591 15.8365 14.6713 15.7301C14.5834 15.6237 14.5266 15.4951 14.5071 15.3585L14.5001 15.2515V12.5265L14.1561 12.5565C11.7561 12.8065 9.45607 13.8875 7.24207 15.8165C6.72207 16.2695 5.91907 15.8415 6.00507 15.1585C6.66907 9.83847 9.45107 6.90747 14.2001 6.53947L14.5001 6.52047ZM16.0001 5.50747V7.25047C16.0001 7.44938 15.9211 7.64014 15.7804 7.7808C15.6397 7.92145 15.449 8.00047 15.2501 8.00047C11.3761 8.00047 8.97607 9.67647 7.93807 13.1575L7.85907 13.4355L8.21107 13.1985C10.4501 11.7375 12.7981 11.0005 15.2511 11.0005C15.4325 11.0005 15.6077 11.0663 15.7443 11.1856C15.8809 11.3049 15.9696 11.4697 15.9941 11.6495L16.0011 11.7505V13.4935L20.1601 9.50047L16.0001 5.50747Z"
        fill="#bf8f02"
      />
    </svg>
  );
};
